import React from 'react'
import QuizComp from '../../components/admin/quiz'
export default function Quiz() {
  return (
    <div>
        <QuizComp/>
    </div>
  )
}
